import { Route, Navigate } from 'react-router';
import RouteSwitch from '../components/RouteSwitch';
import NotFound from '../pages/404';
// import Protected from '../components/Route/ProtectedRoute';

import Login from '../pages/Authentication/Login';
import Logout from '../pages/Authentication/Logout';
import ForgetPassword from '../pages/Authentication/ForgetPassword';
import Register from '../pages/Authentication/Register'
import ClientLinks from './Links';
import { DataEntryLinks, InternalSidebarItemType, SupervisorLinks } from './InternalLinks';
import { ManagementLinks } from './ManagementLinks';
import PracticeDashboard from '../pages/Practice/Dashboard';
import PracticeStaff from '../pages/Practice/Staff';
import PracticeProfile from '../pages/Practice/Profile';
import BusinessProfile from '../pages/Profile';
import UserProfile from '../pages/Profile/UserProfile';
import Billing from '../pages/Billing';
import { useSelector } from 'react-redux';
import { useEffect, useState } from 'react';
import Verify from '../pages/Authentication/Verify';
import ChangePassword from '../pages/Authentication/ChangePassword';
import AddBusiness from '../pages/AddBusiness';
import ComingSoon from '../pages/ComingSoon';

export default function Routes() {
    const user = useSelector((state: any) => state.user.value);

    const [internalLinks, setInternalLinks] = useState<InternalSidebarItemType[]>([]);

    useEffect(() => {
        if (user) {
            if (user.role === 'dataentry') {
                setInternalLinks(DataEntryLinks)
            }
            else if (user.role === 'supervisor') {
                setInternalLinks(SupervisorLinks)
            }
            else if (user.role === 'management') {
                setInternalLinks(ManagementLinks)
            }
        }
    }, [user]);

    return (
        <RouteSwitch>
            {
                user?.role && (
                    user?.role === 'dataentry' || user?.role === 'supervisor' || user?.role === 'management' ?
                        (
                            internalLinks.map((link: any,index) => (
                                <Route
                                    key={index}
                                    path={link.link}
                                    element={<link.element />}
                                />
                            ))
                        )
                        :
                        (
                            ClientLinks.map((link: any,index) => (
                                <Route
                                    key={index}
                                    path={link.link}
                                    element={<link.element />}
                                />
                            ))
                        )
                )
            }

            <Route
                key='1'
                path='/login'
                element={<Login />}
            />

            <Route
                key='2'
                path='/logout'
                element={<Logout />}
            />

            <Route
                key='3'
                path='/verify'
                element={<Verify />}
            />

            <Route
                key='4'
                path='/forgetpassword'
                element={<ForgetPassword />}
            />

            <Route
                key='5'
                path='/password/change'
                element={<ChangePassword />}
            />

            <Route
                key='6'
                path='/register'
                element={<Register />}
            />
           
            <Route
                path='/profile'
                element={<UserProfile />}
            />
           
            <Route
                key='7'
                path='/billing'
                element={<Billing />}
            />

            <Route
                key='cs'
                path='/coming-soon'
                element={<ComingSoon />}
            />

            <Route
                key='8'
                path="/practice/dashboard"
                element={<PracticeDashboard />}
            />

            <Route
                key='9'
                path="/practice/staff"
                element={<PracticeStaff />}
            />

            <Route
                key='10'
                path="/practice/profile"
                element={<PracticeProfile />}
            />

            <Route
                key='11'
                path="/business/profile"
                element={<BusinessProfile />}
            />

            <Route
                key='12'
                path="/business/add"
                element={<AddBusiness />}
            />

            <Route
                key='13'
                path="/"
                element={<Navigate to={
                    !user?.role ?
                        '/login'
                        :
                        (
                            user?.role === 'client' ?
                                '/dashboard'
                                :
                            user?.role === 'management' ?
                                '/management/portal'
                                :
                                '/internal/dashboard'
                        )
                } />}
            />

            <Route
                key='14'
                path='*'
                element={<NotFound />}
            />
        </RouteSwitch>
    );
};